import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import { getLogsService } from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";

export const logAdminContext = createContext({
  logs: [],
  setLogs: () => {},
  id: "",
  setId: () => {},
  to_date: "",
  setTo_date: () => {},
  from_date: "",
  setFrom_date: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  totalCount: null,
  setTotalCount: () => {},
  handleGetLogs: () => {},
});

const LogAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [logs, setLogs] = useState([]);
  const [id, setId] = useState("");
  const [to_date, setTo_date] = useState("");
  const [from_date, setFrom_date] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalCount, setTotalCount] = useState(0);

  // Handle Get Logs Method
  const handleGetLogsList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);


    let from_dateVal = isEmpty(from_date) ? null : from_date?.split("T")[0];
    let to_dateVal = isEmpty(to_date) ? null : to_date?.split("T")[0];

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
      ...(id && { order_id: id }),
      ...(from_dateVal && { from_date: `${from_dateVal} 00:00:00` }),
      ...(to_dateVal && { to_date: `${to_dateVal} 23:59:59` }),
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getLogsService(objData);
      if (status === 200) {
        setLogs(data.list);
        setTotalCount(data.total);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <logAdminContext.Provider
      value={{
        logs,
        setLogs,
        id,
        setId,
        to_date,
        setTo_date,
        from_date,
        setFrom_date,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        totalCount,
        setTotalCount,
        handleGetLogsList,
      }}
    >
      {children}
    </logAdminContext.Provider>
  );
};

export default LogAdminContext;
